import { Stack, Text, ListItem } from '@chakra-ui/react'
import { useEffect } from 'react'

const SchoolLine = ({ selected, school, handleClick }) => {
  const elmID = `school-${school.id}`
  useEffect(() => {
    if (selected) {
      document
        .getElementById(elmID)
        .scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
  })
  let label = null
  if (school.dormant) {
    label = '[dormant]'
  } else if (school.usedForTesting) {
    label = '[test]'
  }
  return (
    <ListItem
      id={elmID}
      isTruncated
      bg={selected ? 'gray.200' : ''}
      _hover={{
        borderColor: 'gray.200',
        bg: 'gray.200',
        cursor: 'pointer',
      }}
      padding={2}
      onClick={handleClick}
    >
      <Stack spacing={0.7}>
        <Stack direction="row">
          <Text fontWeight="600" color="#ffa500">
            {label}
          </Text>
          <Text fontSize="md">{school.name}</Text>
        </Stack>
        <Text fontSize="xs" color="#718096">
          {school.subdomain} &middot; {school.id}
        </Text>
      </Stack>
    </ListItem>
  )
}

export default SchoolLine
